import { IApplicationState } from 'shared/map-search/types/redux';

export const selectClustersType = (state: IApplicationState) => state.clustersType;
